export const TYPE = 'primary';